
(function () {
  'use strict';

  var currentOpenItem = null;

  function setExpanded(item, val) {
    var link = item && item.querySelector('.ab39-nav__link');
    if (link) link.setAttribute('aria-expanded', val ? 'true' : 'false');
  }

  function closeAllDesktop(root) {
    var open = root.querySelectorAll('.ab39-nav__item.is-open');
    for (var i = 0; i < open.length; i++) {
      open[i].classList.remove('is-open');
      setExpanded(open[i], false);
      var p = open[i].querySelector('.ab39-mega,.ab39-dropdown');
      if (p) p.setAttribute('aria-hidden', 'true');
    }
    currentOpenItem = null;
  }

  function openItemDesktop(root, item) {
    if (!item || item === currentOpenItem) return;
    closeAllDesktop(root);
    item.classList.add('is-open');
    setExpanded(item, true);
    var p = item.querySelector('.ab39-mega,.ab39-dropdown');
    if (p) p.setAttribute('aria-hidden', 'false');
    currentOpenItem = item;
  }

  function toggleItemDesktop(root, item) {
    if (item && item === currentOpenItem) closeAllDesktop(root);
    else openItemDesktop(root, item);
  }

  // Click a sidebar category with sub-items -> switch the right panel.
  function swapPanel(sbItem) {
    if (!sbItem || sbItem.getAttribute('data-leaf') === '1') return;
    var mega = sbItem.closest('.ab39-mega');
    if (!mega) return;
    var catId = sbItem.getAttribute('data-cat');

    var sibs = mega.querySelectorAll('.ab39-mega__sidebar-item');
    for (var i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-active');
    sbItem.classList.add('is-active');

    var panels = mega.querySelectorAll('.ab39-mega__panel');
    for (var j = 0; j < panels.length; j++) {
      panels[j].classList.toggle('is-visible', panels[j].getAttribute('data-panel') === catId);
    }
  }

  // Prefer a visible/rendered #ab39-nav-root over a hidden duplicate.
  // (Guards against the snippet accidentally being rendered twice, which
  // produces two elements sharing the same id.)
  function getDesktopNavRoot() {
    var candidates = document.querySelectorAll('#ab39-nav-root');
    if (candidates.length === 0) return null;
    if (candidates.length === 1) return candidates[0];

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.offsetParent !== null) return el; // visible in layout
    }
    return candidates[0]; // fallback: all hidden, just use the first
  }

  // Standalone: hovering a mega item shows the #nav-backdrop overlay.
  // Hovering the backdrop itself (i.e. the rest of the page, outside the
  // menu) hides it again. This does NOT touch is-open / the click toggle
  // logic at all — it only adds/removes the 'is-overlay' class.
  function initNavBackdropHover(root) {
    var backdrop = document.getElementById('nav-backdrop');
    if (!backdrop) return;

    var megaItems = root.querySelectorAll('.ab39-nav__item[data-type="mega"]');
    for (var i = 0; i < megaItems.length; i++) {
      megaItems[i].addEventListener('mouseenter', function () {
        backdrop.classList.add('is-overlay');
      });
    }

    backdrop.addEventListener('mouseenter', function () {
      backdrop.classList.remove('is-overlay');
    });
  }

  function initDesktopNav() {
    var root = getDesktopNavRoot();
    if (!root) return;

    initNavBackdropHover(root);

    root.addEventListener('click', function (e) {
      // Top-level paneled label: toggle only, never navigate.
      var link = e.target.closest('.ab39-nav__link');
      if (link && root.contains(link)) {
        var item = link.closest('.ab39-nav__item');
        var type = item && item.getAttribute('data-type');
        if (type === 'mega') { e.preventDefault(); toggleItemDesktop(root, item); return; }
        return; // plain link: let it navigate normally
      }

      var a = e.target.closest('a[href]');
      if (!a || !root.contains(a)) return;

      // Sidebar category with children -> swap panel, don't navigate.
      var sbItem = a.parentNode;
      var isSidebarBranch = sbItem && sbItem.classList &&
        sbItem.classList.contains('ab39-mega__sidebar-item') &&
        sbItem.getAttribute('data-leaf') !== '1';
      if (isSidebarBranch) { e.preventDefault(); swapPanel(sbItem); return; }

      // Placeholder / no-op links never navigate.
      if (a.getAttribute('data-placeholder') === '1' || a.getAttribute('data-noop') === '1') {
        e.preventDefault();
      }
      // Everything else (real leaf links) navigates normally.
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && currentOpenItem) closeAllDesktop(root);
    });

    // Outside click closes (capture so it runs before the panel's own click).
    document.addEventListener('click', function (e) {
      if (currentOpenItem && !root.contains(e.target)) closeAllDesktop(root);
    }, true);

    // Focusing search closes any open panel.
    var searchInputs = document.querySelectorAll('#search-focus, input[name="q"]');
    for (var si = 0; si < searchInputs.length; si++) {
      searchInputs[si].addEventListener('focus', function () {
        if (currentOpenItem) closeAllDesktop(root);
      });
    }
  }

  /* ============================ MOBILE ============================ */
  /* All levels are already in the DOM (server-rendered). We just slide
     the strip and keep a small stack of level-ids for back/title. */

  var drawerStack = ['root'];

  function getLevelEl(root, levelId) {
    return root.querySelector('.ab39-dr__level[data-level-id="' + cssEscape(levelId) + '"]');
  }

  function cssEscape(s) {
    return String(s).replace(/[^a-zA-Z0-9_-]/g, function (c) {
      return '\\' + c;
    });
  }

  function paintDrawer(root) {
    var levelsEl = root.querySelector('.ab39-dr__levels');
    var titleEl = root.querySelector('.ab39-dr__title');
    var drEl = root.querySelector('.ab39-dr');
    if (!levelsEl) return;

    // Order the (already-existing) level nodes to match the stack, purely
    // via translateX on the container: index = position in the stack.
    var idx = drawerStack.length - 1;
    var currentLevelId = drawerStack[idx];
    var currentLevelEl = getLevelEl(root, currentLevelId);

    // We rely on DOM order for translateX math, so instead of re-ordering
    // nodes we just show the whole strip and translate to the *DOM index*
    // of the current level element.
    var allLevels = Array.prototype.slice.call(levelsEl.children);
    var domIdx = allLevels.indexOf(currentLevelEl);
    if (domIdx === -1) domIdx = 0;
    levelsEl.style.transform = 'translateX(' + (-domIdx * 100) + '%)';

    if (titleEl) titleEl.textContent = currentLevelEl ? (currentLevelEl.getAttribute('data-title') || 'Menu') : 'Menu';
    if (drEl) drEl.classList.toggle('is-nested', idx > 0);
  }

  function pushLevel(root, targetLevelId) {
    if (!getLevelEl(root, targetLevelId)) return;
    drawerStack.push(targetLevelId);
    paintDrawer(root);
  }

  function popLevel(root) {
    if (drawerStack.length > 1) {
      drawerStack.pop();
      paintDrawer(root);
    }
  }

  function resetDrawer(root) {
    drawerStack = ['root'];
    paintDrawer(root);
  }

function initMobileDrawer() {
  var root = document.getElementById('ab39-drawer-root');
  if (!root) return;

  if (!document.__ab39DrawerDelegated) {
    document.__ab39DrawerDelegated = true;

    document.addEventListener('click', function (e) {
      var root = document.getElementById('ab39-drawer-root');
      if (!root || !root.contains(e.target)) return;

      var close = e.target.closest('[data-act="close"]');
      if (close) { e.preventDefault(); /* ... existing close logic ... */ return; }

      var back = e.target.closest('[data-act="back"]');
      if (back) { e.preventDefault(); popLevel(root); return; }

      var push = e.target.closest('[data-act="push"]');
      if (push) { e.preventDefault(); pushLevel(root, push.getAttribute('data-target')); return; }

      var a = e.target.closest('a[href]');
      if (a && a.getAttribute('data-placeholder') === '1') e.preventDefault();
    });
  }

  drawerStack = ['root'];   // root replace হলে stack-ও reset করা দরকার
  paintDrawer(root);
}
  /* ============================ BOOT ============================ */

//   function boot() {
//     initDesktopNav();
//     initMobileDrawer();
//   }
function boot() {
  if (document.getElementById('ab39-nav-root')) {
    document.body.classList.add('ab39-on');
  }
  initDesktopNav();
  initMobileDrawer();
}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // If your drawer section re-renders itself dynamically (theme reloads
  // its content via AJAX), re-init after it does:
  document.addEventListener('shopify:section:load', boot);
})();